// extracted by mini-css-extract-plugin
export default {"cart":"cart___vW_uF","totalDisclaimer":"total-disclaimer___tGZpg","totalItems":"total-items___jTMVq","totalPrice":"total-price___eofp1","cartItems":"cart-items___BNXRf"};